export default "__VITE_ASSET__DZvkSOOV__"